import { render } from "./security.vue?vue&type=template&id=483dfeea&scoped=true"
import script from "./security.vue?vue&type=script&lang=js"
export * from "./security.vue?vue&type=script&lang=js"

import "../less/profileSettings.less?vue&type=style&index=0&id=483dfeea&scoped=true&lang=css&external"
import "./security.vue?vue&type=style&index=1&id=483dfeea&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483dfeea"]])

export default __exports__